export default __webpack_public_path__ + "static/media/tool-icon-shirt-black-15.8bff9ec3.svg";